// Module
var code = "<div class=\"fullscreen-dialog\"> <h1>{{ notification.ShortText }}</h1> <a class=\"close-dialog\" href=\"#\" @click.stop.prevent=\"close()\" aria-label=\"Close dialog\"><icon name=\"close\"></icon></a> <notification-view v-if=\"notification\" :notification=\"notification\"></notification-view> </div>";
// Exports
export default code;